"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./DropdownButton.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * DropdownButton component is used for compose select with dropdown
 */
const DropdownButton = /*#__PURE__*/React.forwardRef(({
  text,
  variant = 'primary',
  textSize = 's',
  textFont,
  disabled,
  isOpen,
  padding = [8, 16],
  ...otherProps
}, ref) => {
  let color = isOpen ? 'interactive.primary.default' : 'text.1';
  const isSecondaryVariant = variant === 'secondary';

  if (isSecondaryVariant) {
    color = 'interactive.primary.default';
  }

  if (disabled) {
    color = 'disabled.3';
  }

  return (0, _pragma.createFelaElement)(_.View, _extends({
    css: css.button,
    cssProps: {
      isOpen,
      disabled,
      variant
    },
    padding: padding,
    alignItems: "center",
    as: "button",
    disabled: disabled,
    ref: ref
  }, otherProps), text && (0, _pragma.createFelaElement)(_.Text, _extends({
    variant: "metaBold",
    size: textSize,
    color: color
  }, textFont ? {
    family: textFont
  } : {}), text), isOpen ? (0, _pragma.createFelaElement)(_.ChevronUpIcon, {
    css: css.icon,
    size: "small",
    color: color
  }) : (0, _pragma.createFelaElement)(_.ChevronDownIcon, {
    css: css.icon,
    size: "small",
    color: color
  }));
});
DropdownButton.displayName = 'DropdownButton';
var _default = DropdownButton;
exports.default = _default;
//# sourceMappingURL=DropdownButton.js.map